import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/css3': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 32l-64 368-223.3 80-192.7-80 19.6-94.8h82l-8 40.6 116.4 44.4 134.1-44.4 18.8-97.1h-333.4l16-82h333.7l10.5-52.7h-333.4l16.3-82h407.4z'
      }
    ]
  }
})
